import { datadogRum } from '@datadog/browser-rum';

import { openNonEssentialImportWindow } from './chunkReload';
import { runWhenIdle } from './runWhenIdle';

// Session replay starts deferred so the recorder's initial DOM serialization
// lands after React commits rather than competing with the mount. Deferring is
// what provides that ordering, not the call's position below root.render:
// root.render schedules concurrent work and does not commit synchronously, and
// React's scheduler drains on a MessageChannel macrotask, which runs ahead of
// both branches here.
//
// The idle deadline bounds how long a busy tab may postpone recording. WebKit
// does not implement requestIdleCallback outside a feature flag, so Safari and
// every iOS browser take the timer branch: that is the common path on candidate
// mobile traffic, not a legacy edge case, and it gets a short fixed delay so
// those sessions are not blind for the full idle deadline.
const SESSION_REPLAY_IDLE_DEADLINE_MS = 2000;
const SESSION_REPLAY_TIMER_DELAY_MS = 200;
// Starting replay fetches the recorder chunk. A failed fetch inside this window
// is reported instead of reloading the page (see chunkReload).
const SESSION_REPLAY_IMPORT_WINDOW_MS = 30000;

export const startSessionReplayWhenIdle = (): void => {
  // Wrapped rather than passed by reference so an IdleDeadline is never
  // forwarded as the SDK's StartRecordingOptions argument.
  const start = () => {
    openNonEssentialImportWindow(SESSION_REPLAY_IMPORT_WINDOW_MS);
    datadogRum.startSessionReplayRecording();
  };
  runWhenIdle(start, {
    idleTimeoutMs: SESSION_REPLAY_IDLE_DEADLINE_MS,
    fallbackDelayMs: SESSION_REPLAY_TIMER_DELAY_MS,
  });
};
